import type { Translatable } from "app/pages/sales-intelligence/types";

import type { LeadsType } from "../../../types";

export const SEARCH_PLACEHOLDER_MAP: Record<LeadsType, Translatable> = {
    websites: { key: "si.components.advanced_search_results_table.search_placeholder" },
    companies: { key: "si.components.advanced_search_results_table.companies.search_placeholder" },
};
